import { clearFiltersError } from 'actions/scheduled_events/filters'

export const selectFilterItem = (filterName, group, item) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'SET_FILTER_ITEM',
    payload: {
      name: filterName,
      groupKey: group.key,
      itemId: item.id,
      selected: true
    }
  })
}

export const unselectFilterItem = (filterName, group, item) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'SET_FILTER_ITEM',
    payload: {
      name: filterName,
      groupKey: group.key,
      itemId: item.id,
      selected: false
    }
  })
}

export const bulkDisableFilterItems = (filterName, groupsToETs) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'BULK_DISABLE_FILTER_ITEMS',
    payload: {
      filterName,
      groupsToETs
    }
  })
}

export const selectAllFilterItems = (filterName) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'SET_ALL_FILTER_ITEMS',
    payload: {
      name: filterName,
      selected: true
    }
  })
}

export const unselectAllFilterItems = (filterName) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'SET_ALL_FILTER_ITEMS',
    payload: {
      name: filterName,
      selected: false
    }
  })
}
